import { render, staticRenderFns } from "./Selects.vue?vue&type=template&id=45fbf729&"
import script from "./Selects.vue?vue&type=script&lang=js&"
export * from "./Selects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports